import React, { ReactElement } from 'react';
import classNames from 'classnames';
import { CUSTOM_TOP_DATA } from 'modules/shared/layout/menu/components/custom-top/custom-top.data';
import ranking from 'assets/icons/global/ranking-color.svg';

import './custom-top.desktop.scss';

const CustomTopDesktop: React.FC = (): ReactElement | null => {
    return (
        <div className="custom-top-desktop" data-section="top-bar">
            {CUSTOM_TOP_DATA.map(item => (
                <a
                    key={item.url}
                    className={classNames('custom-top-desktop__item', {
                        'custom-top-desktop__item--ranking': item.isRanking
                    })}
                    href={item.url}
                    title={item.title}
                >
                    {item.isRanking && (
                        <img src={ranking} alt="Ranking icon" width={24}
                            height={24}
                        />
                    )}
                    {item.title}
                </a>
            ))}
        </div>
    );
};

export default CustomTopDesktop;
